import React from 'react';
import { useIntl, defineMessages } from 'react-intl-next';

import { Box, Flex, Stack, xcss, Text } from '@atlaskit/primitives';
import Heading from '@atlaskit/heading';
import { useThemeObserver } from '@atlaskit/tokens';

import gesturalLine from './assets/gestural-line.svg';
import gesturalLineDark from './assets/gestural-line-dark.svg';

export const messages = defineMessages({
	recommended: {
		id: 'experiment-aua-improve-conversion.floating-recommendation.recommended',
		defaultMessage: 'Recommended',
		description: "One word to tell the user that the Standard edition is 'recommended' for them.",
	},
	basedOnYourUsage: {
		id: 'experiment-aua-improve-conversion.floating-recommendation.based-on-your-usage',
		defaultMessage: 'based on your usage',
		description: "This is the reason we're recommending the Standard edition to the user.",
	},
	gesturalLineAltText: {
		id: 'experiment-aua-improve-conversion.floating-recommendation.gestural-line-alt-text',
		defaultMessage: 'A gesture pointing towards the Standard edition',
		description:
			'An image of a line that gestures towards the Standard edition showing that Standard is being recommended.',
	},
});

/**
 * This is the floating recommendation component.
 */
export const FloatingRecommendation = () => {
	const { formatMessage } = useIntl();
	const { colorMode } = useThemeObserver();

	return (
		<Box xcss={floatingElementsStyles}>
			<Flex xcss={horizontalFlexStyles}>
				<Stack space="space.050">
					<Heading size="medium">{formatMessage(messages.recommended)}</Heading>
					<Text size="medium">{formatMessage(messages.basedOnYourUsage)}</Text>
				</Stack>
				<Box xcss={gesturalLineStyles}>
					{colorMode === 'dark' ? (
						<img src={gesturalLineDark} alt={formatMessage(messages.gesturalLineAltText)} />
					) : (
						<img src={gesturalLine} alt={formatMessage(messages.gesturalLineAltText)} />
					)}
				</Box>
			</Flex>
		</Box>
	);
};

const floatingElementsStyles = xcss({
	position: 'absolute',
	zIndex: 'dialog',
	left: 'space.200',
	top: 'space.300',
});

const horizontalFlexStyles = xcss({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'flex-start',
});

const gesturalLineStyles = xcss({
	marginLeft: 'space.200',
	marginTop: 'space.200',
});
